// change-password-page.component.ts
import { Component } from '@angular/core';

@Component({
    selector: 'ml-change-password-page',
    template: '<ml-change-password></ml-change-password>',
})
export class ChangePasswordPageComponent { }
